// Shared FE constants for the new-topic-modelling taxonomy + dual-agent annotation flow.
// Mirrors the BE counterpart in `okf-be/ai/dualAgentAnnotation/config.js`.

// Special-cased attribute category whose tags are extracted dynamically from
// text rather than picked from a fixed vocabulary. Identified by `tagId` on
// the attribute subTheme (which becomes `key` on the attribute category).
export const NAMED_ENTITIES_KEY = "named_entities";
